import React from 'react';
import { Button, Heading, TextWrapper } from '../../globalStyles';
import { IconContext } from 'react-icons/lib';
import {
	ApplicationsSection,
	ApplicationsWrapper,
	ApplicationsContainer,
	ApplicationsCardInfo,
	ApplicationsCardPlan,
	ApplicationsCardCost,
	ApplicationsCardFeatures,
	ApplicationsCardText,
	ApplicationsCardFeature,
	ApplicationsCard,
} from './ApplicationsStyles';
import { ApplicationsData } from '../../data/ApplicationsData';
import './apps.css'

import { Link } from 'react-router-dom';


function Applications() {
	return (
		<IconContext.Provider value={{ color: '#a9b3c1', size: '1rem' }}>
			<ApplicationsSection id="pricing" className='marginApp'>
				<ApplicationsWrapper>
					<Heading value={{ margin: "80px" }}>Apps</Heading>

					
					<ApplicationsContainer>
						{ApplicationsData.map((card, index) => (
							<ApplicationsCard key={index}>
								<ApplicationsCardInfo>
									<ApplicationsCardPlan>{card.title}</ApplicationsCardPlan>
									<ApplicationsCardCost>{card.price}</ApplicationsCardCost>
									<ApplicationsCardText>{card.description}</ApplicationsCardText>
									<ApplicationsCardFeatures>
										{card.features.map((feature, index) => (
											<ApplicationsCardFeature key={index}>
												{feature}
											</ApplicationsCardFeature>
										))}
									</ApplicationsCardFeatures>

									

									
                                    <div className="btn-group">

								
									<a href={card.urlApp} target="_blank">
									<button id="btnTry">Try it</button>
									</a>	
									<Link to={card.to}>
									<button id='btnDoc'>Documentation</button>
									</Link>
									
                                    </div>
								

								</ApplicationsCardInfo>
							</ApplicationsCard>
						))}
					</ApplicationsContainer>
				</ApplicationsWrapper>
			</ApplicationsSection>
		</IconContext.Provider>
	);
}
export default Applications;
